import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import '@/i18n';
import { registerOfflineServiceWorker } from '@/offline/registerServiceWorker';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found in index.html.');
}

registerOfflineServiceWorker();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
